"use client"

import { Navigation } from "@/components/common/header"
import Footer from "@/components/common/footer"
import { usePathname } from "next/navigation"
import { MobileFooter } from '@/components/common/MobileFooter'

interface CommonLayoutProps {
  children: React.ReactNode
}

const ROUTES_WITHOUT_LAYOUT = ["/payment"]
const ROUTES_WITH_LAYOUT_MOB = ["/"]

export function CommonLayout({ children }: CommonLayoutProps) {
  const pathname = usePathname()
  const showLayout = !ROUTES_WITHOUT_LAYOUT.includes(pathname)
  const mobLayout = ROUTES_WITH_LAYOUT_MOB.includes(pathname)

  return (
    <>
      {showLayout && <Navigation />}
        {children}
      {mobLayout && <MobileFooter />}
      {showLayout && <Footer />}
    </>
  )
}